import { ReactComponent as HeartOffGrayIcon } from '@assets/images/app/heart-gray.svg';
import { ReactComponent as HeartOffWhiteIcon } from '@assets/images/app/heart-white.svg';

import React from 'react';

interface FavoriteButtonProps {
  productId?: string;
  saleType?: string;
  style?: any;
  theme?: string;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = (props) => {
  return (
    <button
      className="link-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        ...props.style,
      }}>
      {props.theme === 'white' ? <HeartOffWhiteIcon /> : <HeartOffGrayIcon />}
    </button>
  );
};

export default FavoriteButton;
